export default {"src":"/_next/static/media/wolframalpha.1ac762c0.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};